import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { saga } from "./saga";
import { IReportingScalarState } from "./types";

export * from "./ReportingScalar";

export const reportingScalarModule: ApplicationStatefulModule<typeof NAME, Reducer<IReportingScalarState>> = {
    NAME,
    reducer,
    saga,
};
